<template>
  <div class="big-screen">
    <div class="logo">
      <img class="logo-img" src="../../../assets/images/big-screen/screen-logo.png" alt />
    </div>
    <div class="container">
      <div class="title">
        <img class="title-img" src="../../../assets/images/big-screen/screen-title.png" alt />
      </div>
      <div class="content">
        <!-- <p class="num">5</p>
        <p class="num">5</p>
        <p class="num">5</p>
        <div class="semicolon-container">
          <p class="semicolon">,</p>
        </div>
        <p class="num">5</p>
        <p class="num">5</p>
        <p class="num">5</p>-->
        <template v-for="(value,index) in orderNum">
          <p v-if="value !==','" class="num" :key="index">{{value}}</p>
          <div v-else class="semicolon-container" :key="index">
            <p class="semicolon">{{value}}</p>
          </div>
        </template>
      </div>
      <div class="total">
        <div class="total-tit">
          <p class="circle"></p>
          <span>累计出库单量</span>
          <p class="circle"></p>
        </div>
        <div class="total-num">{{total}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import DataState from "models/data-state";
const dataState = new DataState();
export default {
  data() {
    return {
      orderNum: "",
      total: ""
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    setInterval(() => {
      this.getData();
    }, 180000);
  },
  methods: {
    getData() {
      dataState.getScreenData().then(res => {
        if (res.success) {
          this.orderNum = this.toThousands(res.result.today);
          this.total = this.toThousands(res.result.total);
        }
      });
    },
    //获取数字逗号
    toThousands(number) {
      number = number + "";
      number = number.replace(/\,/g, "");
      if (isNaN(number) || number == "") return "";
      number = Math.round(number * 100) / 100;
      if (number < 0)
        return (
          "-" +
          this.outputdollars(Math.floor(Math.abs(number) - 0) + "") +
          outputcents(Math.abs(number) - 0)
        );
      else return this.outputdollars(Math.floor(number - 0) + "");
    },
    outputdollars(number) {
      if (number.length <= 3) return number == "" ? "0" : number;
      else {
        var mod = number.length % 3;
        var output = mod == 0 ? "" : number.substring(0, mod);
        for (let i = 0; i < Math.floor(number.length / 3); i++) {
          if (mod == 0 && i == 0)
            output += number.substring(mod + 3 * i, mod + 3 * i + 3);
          else output += "," + number.substring(mod + 3 * i, mod + 3 * i + 3);
        }
        return output;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.big-screen {
  height: 100vh;
  width: 100vw;
  background: url(../../../assets/images/big-screen/screen-bj.png);
  background-size: cover;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    position: absolute;
    left: 60px;
    top: 40px;
    .logo-img {
      width: 88px;
      height: 88px;
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-bottom: 52px;
      .title-img {
        width: 526px;
        height: 71px;
      }
    }
  }
  .content {
    width: 899px;
    height: 260px;
    background: url(../../../assets/images/big-screen/screen-content.png);
    background-size: cover;
    margin-bottom: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    .num {
      width: 120px;
      height: 174px;
      background: rgba(0, 0, 0, 0.5);
      border: 2px solid rgba(106, 124, 144, 1);
      font-size: 116px;
      color: #cee8fe;
      font-weight: 500;
      border-radius: 6px;
      margin: 0 6px;
      text-align: center;
      line-height: 174px;
      box-sizing: border-box;
    }
    .semicolon-container {
      width: 30px;
      font-size: 64px;
      color: #cee8fe;
      text-align: center;
      height: 174px;
      font-weight: 500;
      position: relative;
      .semicolon {
        position: absolute;
        bottom: 0;
        left: 6px;
        text-align: center;
        font-family: "DIN";
      }
    }
  }
  .total {
    width: 534px;
    height: 160px;
    background: url(../../../assets/images/big-screen/screen-total.png);
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    .total-tit {
      padding-top: 26px;
      font-size: 32px;
      color: rgba(204, 230, 249, 1);
      display: flex;
      align-items: center;
      .circle {
        margin: 0 16px;
        width: 5px;
        height: 5px;
        background: rgba(206, 232, 254, 1);
        border-radius: 50%;
      }
    }
    .total-num {
      padding-top: 40px;
      font-size: 40px;
      font-weight: 500;
      color: rgba(66, 201, 219, 1);
    }
  }
}
</style>